// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"246":"669d42f2a818228d","337":"2b71510c5871f6f5","376":"35351cb63f033da9","599":"9c2d8cbef602c83e","672":"e0efeed79ea3d5d0","794":"6d3ef31964a4a468","898":"f197e7f4fa7d629f","914":"dfeb96ad7e869ecf","961":"4e4b93755911dd65"}[chunkId] + ".js";
};